<h2 mat-dialog-title>
  <mat-icon>pause_circle</mat-icon>
  You are about to inactivate this property
</h2>
<form [formGroup]="inactivateForm">
  <mat-dialog-content class="column">
    <mat-radio-group class="row" formControlName="reason" aria-label="Please state the reason why you want inactivate it">
      <mat-radio-button class="row" value="Owner is now living in the home">Owner is now living in the home</mat-radio-button>
      <mat-radio-button class="row" value="Owner doesn’t own the house anymore">Owner doesn’t own the house anymore</mat-radio-button>
      <mat-radio-button class="row" value="Owner have a written lease longer than 6 months">Owner have a written lease longer than 6 months</mat-radio-button>
      <mat-radio-button class="row" value="Owner no longer renting the property">Owner no longer renting the property</mat-radio-button>
      <mat-radio-button class="row" value="Other reason">Other reason</mat-radio-button>
    </mat-radio-group>
    <mat-form-field class="row" appearance="outline">
      <mat-label>Last date short-term rentals to remit</mat-label>
      <input formControlName="lastRented" [matDatepicker]="picker" matInput>
      <mat-hint>MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle [for]="picker" matIconSuffix></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <mat-form-field class="row" appearance="outline">
      <mat-label>Comments</mat-label>
      <textarea formControlName="comments" matInput placeholder="Explain the reason in a max of 400 characters"></textarea>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button class="go-back" mat-button mat-dialog-close>GO BACK</button>
    <button [disabled]="inactivateForm.invalid" cdkFocusInitial class="approve"
            (click)="inactivate()" mat-button>SEND REQUEST</button>
  </mat-dialog-actions>
</form>

